import React from "react";
import { Route, RouteProps, useHistory } from "react-router-dom";

import {
  FeatureFlagEnum,
  ModuleFeatureFlagEnum,
  neutralColors,
} from "@pulsemarket/constants";
import { Loading } from "components/FullScreenLoading";
import Button from "components/ui/Button";
import NoContent from "components/ui/NoContent";
import { useGetAuthToken } from "hooks/queries/useAuth";
import useFeatureEnabled from "hooks/useFeatureEnabled";
import { zeroPaddingMargin } from "shared/styles/classes";
import { typography } from "shared/styles/typography";
import { stylesheet } from "typestyle";
type PrivateRouteProps = RouteProps & {
  featureName?: ModuleFeatureFlagEnum | FeatureFlagEnum;
  children?: React.ReactNode;
};

const PrivateRoute = ({
  children,
  featureName,
  ...rest
}: PrivateRouteProps) => {
  const { isLoading, isError, data: userData } = useGetAuthToken();

  const { data: featureFlag } = useFeatureEnabled({
    featureName: featureName as unknown as FeatureFlagEnum,
  });

  if (isLoading && !isError) {
    return <Loading />;
  }

  const pageNotFound =
    isError || !userData?.userId || (!!featureName && !featureFlag);
  // &&
  // pathname !== "/";

  return (
    <Route
      {...rest}
      render={({ location }) => {
        return pageNotFound ? <NotFoundPage /> : children;
      }}
    />
  );
};

export default PrivateRoute;

const styles = stylesheet({
  emptyContent: {
    ...typography.BODY2,
    color: neutralColors.GRAY4,
    textAlign: "center",
    ...zeroPaddingMargin,
  },
  emptyContentTitle: {
    ...typography.BODY2,
    color: neutralColors.GRAY4,
    textAlign: "center",
    marginBottom: "24px",
  },
});
function NotFoundPage() {
  const history = useHistory();
  return (
    <NoContent
      className={styles.emptyContent}
      icon={{ src: "/icons/question_icon.svg" }}
    >
      <div className={styles.emptyContentTitle}>
        The page you are looking for does not exist.
      </div>
      <Button
        variant="outlined"
        color="orange"
        onClick={() => {
          history.push("/");
        }}
      >
        Go to Dashboard
      </Button>
    </NoContent>
  );
}
